import React from 'react';
import PropTypes from 'prop-types';
import ContentContainer from './ContentContainer';

class NoticeBar extends React.Component {
    render() {
        const { notice, icon } = this.props;
        const classes = ['NoticeBar', ...this.props.classes];
        return (
            <div className={classes.join(' ')}>
                <ContentContainer className="NoticeBar__inner">
                    {icon && <div className="NoticeBar__icon">{icon}</div>}
                    <p className="NoticeBar__notice">{notice}</p>
                </ContentContainer>
            </div>
        );
    }
}

NoticeBar.propTypes = {
    classes: PropTypes.arrayOf(PropTypes.string),
    notice: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    icon: PropTypes.node,
};

NoticeBar.defaultProps = {
    icon: null,
    classes: [],
};

export default NoticeBar;
